// ==============================|| OVERRIDES - OUTLINED INPUT ||============================== //
import type { Theme } from '@mui/material';

export default function OutlinedInput(theme: Theme) {
    return {
        MuiOutlinedInput: {
            styleOverrides: {
                input: {
                    padding: '10.5px 14px 10.5px 12px',
                },
                notchedOutline: {
                    borderColor: theme.palette.grey[300],
                },
                root: {
                    '&.MuiInputBase-sizeSmall': {
                        fontSize: '14px',
                    },

                    '&:hover .MuiOutlinedInput-notchedOutline': {
                        border: `1px solid ${theme.palette.grey[900]}`,
                    },

                    '&.Mui-disabled': {
                        pointerEvents: 'none',
                    },

                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        border: `2px solid ${theme.palette.primary.main}`,
                    },

                    '&.Mui-error  .MuiOutlinedInput-notchedOutline': {
                        border: `1px solid ${theme.palette.error.main}`,
                    },
                },
                inputSizeSmall: {
                    padding: '6px 8px',
                    fontSize: '14px',
                },
                inputMultiline: {
                    padding: 0,
                },
            },
        },
    };
}
